import store from "../store.js";
import {addLogEntry, selectSim} from "../simSlice.js";
import {selectPlane} from "../planeSlice.js";

export default class PlaneAction {
    constructor(planeId) {
        this.planeId = planeId;
    }

    log(message) {
        store.dispatch(addLogEntry({planeId: this.planeId, message: message}));
    }

    dispatch(action) {
        if (!action.payload?.planeId) {
            action = { ...action, payload: { ...action.payload, planeId: this.planeId }};
        }
        store.dispatch(action);
    }

    getState() {
        return selectPlane(store.getState(), this.planeId);
    }

    getSimState() {
        return selectSim(store.getState());
    }

    execute() {
        throw new Error("execute() method must be implemented");
    }

    isComplete() {
        throw new Error("isComplete() method must be implemented");
    }
}
